'use client';
import { ActionCard } from '../actionCard';
import { MaterialIconType } from '../materialIcon';

/**
 * Card with title and optional description that opens a link on a new tab. Same look as every other ActionCard.
 *
 * @param {string} title - The title of the link button.
 * @param {string} description - The optional description of the link button.
 * @param {string} link - The link URL to open.
 * @return {React.JSX.Element} The rendered link button.
 */
export function LinkButton({
  title,
  description,
  link,
  icon,
}: {
  title: string;
  description?: string;
  link: string;
  icon: MaterialIconType;
}) {
  return (
    <ActionCard data-testid="linkButton" icon={icon} title={title} description={description} href={link} external />
  );
}
